function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { useCallback } from "react";
import { useTopicButton_AcceptTopicInviteMutation, ItemType, ItemMemberLevel, useTopicButton_InviteUserToTopicMutation } from "sprout-graphql";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
function useAcceptTopicInvite({ topicId , userId , nodeId , teamMembersJoinAs , memberLevel  }) {
    const showSnackbar = useSnackbar();
    const [acceptTopicInvite] = useTopicButton_AcceptTopicInviteMutation({
        variables: {
            topicId
        },
        optimisticResponse: {
            acceptTopicInvite: {
                itemByTopicId: {
                    nodeId,
                    id: topicId,
                    type: ItemType.Topic,
                    memberLevel: ItemMemberLevel.Contributor,
                    __typename: "Item"
                }
            }
        }
    });
    const [inviteUserToTopic] = useTopicButton_InviteUserToTopicMutation({
        variables: {
            topicId,
            userId,
            asRole: teamMembersJoinAs
        },
        optimisticResponse: {
            inviteUserToTopic: {
                itemByTopicId: {
                    nodeId,
                    id: topicId,
                    type: ItemType.Topic,
                    memberLevel: ItemMemberLevel.Contributor,
                    __typename: "Item"
                }
            }
        }
    });
    return useCallback(_asyncToGenerator(function*() {
        try {
            if (memberLevel === ItemMemberLevel.Invited) yield acceptTopicInvite();
            else yield inviteUserToTopic({
                variables: {
                    asRole: teamMembersJoinAs,
                    topicId,
                    userId
                }
            });
            showSnackbar({
                message: "You have joined the tree"
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        acceptTopicInvite,
        inviteUserToTopic,
        memberLevel,
        showSnackbar,
        teamMembersJoinAs,
        topicId,
        userId, 
    ]);
}
export default useAcceptTopicInvite;
